import type from '../types.js'

export default {
    state:{
        curSpecial:{}
    },
    mutations: {
        [type['CUR_SPECIAL']](state, data) {
            state.curSpecial = data
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/special.js